import { render, staticRenderFns } from "./ReportingForm.vue?vue&type=template&id=5b256248&scoped=true&"
import script from "./ReportingForm.vue?vue&type=script&lang=js&"
export * from "./ReportingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b256248",
  null
  
)

export default component.exports